// Light or dark: the device's setting (System) unless I choose Light or Dark, kept on this device.
// Souvenir's tokens and Tripmo's own dark rules read `data-theme` on <html>; without it they follow the
// device. index.html applies the saved choice before anything draws, so nothing flashes.

export type Appearance = "system" | "light" | "dark";

const KEY = "tripmo:appearance";
const EVENT = "tripmo:appearance";
const PAPER = { light: "#fbf8f3", dark: "#16130f" } as const;

export function savedAppearance(): Appearance {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function setAppearance(choice: Appearance) {
  try {
    if (choice === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    // Private windows can refuse storage: the choice still holds until the page closes.
  }
  applyAppearance(choice);
  dispatchEvent(new Event(EVENT));
}

export function applyAppearance(choice: Appearance) {
  const root = document.documentElement;
  if (choice === "system") delete root.dataset["theme"];
  else root.dataset["theme"] = choice;
  // The browser's own bars, matching the page.
  for (const meta of document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')) {
    const own = meta.media.includes("dark") ? "dark" : "light";
    meta.content = PAPER[choice === "system" ? own : choice];
  }
}

export function onAppearance(listener: () => void): () => void {
  addEventListener(EVENT, listener);
  return () => removeEventListener(EVENT, listener);
}
